import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  header: {
    marginTop: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
  },
  text: {
    marginTop: '5vh',
    marginRight: '10%',
    marginLeft: '10%',
  },
  paper: {
    backgroundColor: theme.palette.blue.lightest,
    padding: theme.spacing(3),
  },
  view: {
    backgroundColor: theme.palette.common.white,
    width: 'inherit',
    textAlign: 'justify',
    height: '700px',
  },
}));
